var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderWithoutSubstrate.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderWithoutSubstrate = ({
  color = '#353B60',
  opacity = '0.25',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "40",
  height: "34",
  viewBox: "0 0 40 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    opacity: opacity,
    d: "M17.18 2.0721C16.42 1.28835 15.4 0.855225 14.34 0.855225H4C1.8 0.855225 0.02 2.71147 0.02 4.98022L0 29.7302C0 31.999 1.8 33.8552 4 33.8552H36C38.2 33.8552 40 31.999 40 29.7302V9.10522C40 6.83647 38.2 4.98022 36 4.98022H20L17.18 2.0721Z",
    fill: color
  })
});